import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';


import { Cliente } from '../../../cliente';
import { ConfigServerService, CustomHttp } from '../../../../../../core';
import { ClienteIntegracaoImportFilter } from '../../cliente-integracao-import-filter';

@Injectable({
    providedIn: 'root'
})
export class ClienteIntegracaoErpImportHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApiIntegrationErp()}/cliente`;
    }

    /** Realiza a importação dos clientes através da integração com o ERP */
    importMany(filter: ClienteIntegracaoImportFilter): Observable<Cliente[]> {
        // Filter
        if (filter) {
            filter.cnpjsCpfs = filter.cnpjCpf ? [filter.cnpjCpf] : []
        }

        return this.customHttp.post<Cliente[]>(`${this.pathApi}/0/import/many`, filter);
    }

    /* Realiza a importação do cliente informado através da integração com o ERP **/
    importOne(idCliente: number): Observable<Cliente> {
        return this.customHttp.get<Cliente>(`${this.pathApi}/${idCliente}/import/one`);
    }
}
